import React, { useState, useEffect, useRef } from "react";

const AudioToggleButton = ({ audioRef }) => {
  const [visible, setVisible] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [ended, setEnded] = useState(false);
  const trackedAudioRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const audio = audioRef.current;

      // If audioRef swapped to a new audio element, attach listeners to it
      if (audio && audio !== trackedAudioRef.current) {
        // Clean up old listeners
        if (trackedAudioRef.current) {
          trackedAudioRef.current.removeEventListener("play", onPlay);
          trackedAudioRef.current.removeEventListener("ended", onEnded);
        }
        trackedAudioRef.current = audio;
        // Carry over mute state to new audio
        audio.muted = isMuted;
        audio.addEventListener("play", onPlay);
        audio.addEventListener("ended", onEnded);
      }

      // Update visibility
      if (audio && !audio.paused && !audio.ended) {
        setVisible(true);
        setEnded(false);
      }
    }, 300);

    function onPlay() {
      setVisible(true);
      setEnded(false);
    }

    function onEnded() {
      setEnded(true);
      setVisible(false);
      setIsMuted(false);
    }

    return () => {
      clearInterval(interval);
      if (trackedAudioRef.current) {
        trackedAudioRef.current.removeEventListener("play", onPlay);
        trackedAudioRef.current.removeEventListener("ended", onEnded);
        trackedAudioRef.current = null;
      }
    };
  }, [audioRef, isMuted]);

  const toggleMute = () => {
    if (!audioRef.current) return;
    if (isMuted) {
      audioRef.current.muted = false;
      setIsMuted(false);
    } else {
      audioRef.current.muted = true;
      setIsMuted(true);
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={toggleMute}
      disabled={ended}
      title={ended ? "Audio ended" : isMuted ? "Unmute" : "Mute"}
      style={{
        position: "fixed",
        top: "80px",
        right: "20px",
        zIndex: 9999,
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        background: ended
          ? "#b0b0b0"
          : "linear-gradient(135deg, #667eea, #764ba2)",
        color: "#fff",
        fontSize: "20px",
        cursor: ended ? "not-allowed" : "pointer",
        opacity: ended ? 0.5 : 1,
        boxShadow: ended ? "none" : "0 4px 15px rgba(102, 126, 234, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "transform 0.2s ease, opacity 0.3s ease",
      }}
      onMouseEnter={(e) => !ended && (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <i className={`fa-solid ${ended || isMuted ? "fa-volume-xmark" : "fa-volume-high"}`}></i>
    </button>
  );
};

export default AudioToggleButton;
